import { UpdateBasketItemSource } from '@epicuro-next/data/baskets-dto';
import {
  BasketAccountAddress,
  BasketItem,
} from 'graphql-api/baskets-api-interfaces';

import { copyBasketItemToCreate } from '../basket-item-to-basket-update-item/basket-item-to-basket-update-item';
import { basketItemsToShops } from '../basket-items-to-shops/basket-items-to-shops';
import { getBasketItemsToAdd } from '../get-basket-items-to-add/get-basket-items-to-add';
import { getExistedBasketItem } from '../get-existed-basket-items/get-existed-basket-items';

export function getCopyProductsBasketUpdate(
  basketItems: BasketItem[],
  shopFrom: BasketAccountAddress,
  shopsTo: BasketAccountAddress[],
) {
  const itemsToAdd = getBasketItemsToAdd(basketItems, shopFrom, shopsTo);

  const itemsToInsertOrUpdate = itemsToAdd.map((itemToAdd) => {
    // merge quantity with existed
    const existingBasketItem = getExistedBasketItem(
      itemToAdd,
      itemToAdd.accountId,
      itemToAdd.addressId as string,
      basketItems,
    );
    return {
      ...itemToAdd,
      requestedQuantity:
        itemToAdd.requestedQuantity +
        (existingBasketItem?.requestedQuantity ?? 0),
    };
  });

  // clear basketItemId for inserted items so BE creates a new item
  // basketItemId for updated items will be set in getUpdateBasketItemsRequest -> getBasketIdForDeliveryItem
  return basketItemsToShops(
    copyBasketItemToCreate.bind(null, {
      type: UpdateBasketItemSource.CopyShipTo,
    }),
  )(itemsToInsertOrUpdate as BasketItem[]);
}
